<template>
  <div>
    <!-- collapsed -->
    <button type="button" class="btn wf-basket-list-accordian-toggle text-transform-none font-weight-bold"
      data-toggle="collapse" :data-target="sectionId" :class="{'collapsed': !isDefaultExpand}">
      <div class="row">
        <div class="col-md-12">
          <h5 class="primary-heading font-weight-bold">
            {{ title }} : {{ itemCount }}
          </h5>
        </div>
      </div>
      <span class="
               plus-sm-icon
               png-icon
               png-icon-icons-glyph--red-minus-sm
               wf-basket-list-accordian-toggle-inactive
             " />
      <span class="
               plus-sm-icon
               png-icon
               png-icon-icons-glyph--red-plus-sm
               wf-basket-list-accordian-toggle-active
             " />
    </button>
  </div>
</template>

<script>
export default {
  props: ['title', 'sectionId', "itemCount", "isDefaultExpand"]
};
</script>